import React from 'react';
import ReactDOM from 'react-dom';
import { Spin } from 'antd';
import style from './index.scss';

window.loadingCount = 0;
window.loadingExportCount = 0;
const LoadingModal = {
  showLoading(text) {
    const prompt = text || '数据获取中，请耐心等待.....';
    if (window.loadingCount <= 0) {
      ReactDOM.render(
        <div className={style.loadingModal}>
          <div className={style.loadingModalSpin}>
            <div>{prompt}</div>
            <Spin size="large"></Spin>
          </div>
        </div>,
        document.getElementById('sy-loading'),
      );
    }
    window.loadingCount++;
  },
  hideLoading() {
    if (window.loadingCount === 0) return;
    window.loadingCount--;
    if (window.loadingCount === 0) {
      ReactDOM.unmountComponentAtNode(document.getElementById('sy-loading'));
    }
  },

  showExportLoading(text) {
    const prompt = text || '数据导出中，请耐心等待.....';
    if (window.loadingExportCount <= 0) {
      ReactDOM.render(
        <div className={style.loadingExportModal}>
          <div className={style.loadingExportModalSpin}>
            <Spin size="large"></Spin>
            <div>{prompt}</div>
          </div>
        </div>,
        document.getElementById('export-loading'),
      );
    }
    window.loadingExportCount++;
  },

  hideExporLoading() {
    if (window.loadingExportCount === 0) return;
    window.loadingExportCount--;
    if (window.loadingExportCount === 0) {
      ReactDOM.unmountComponentAtNode(document.getElementById('export-loading'));
    }
  },
};

export default LoadingModal;
